import { useForm } from 'react-hook-form';
import { useQuerySearchParams, useUpdateQueryParams } from 'hooks/routes';
import Checkbox from 'components/Checkbox';
import styles from './HeaderFilterCheckbox.module.css';

type Props = {
  filterKey: string;
  label: string;
};

const HeaderFilterCheckbox: React.FC<Props> = ({ label, filterKey }) => {
  const [value] = useQuerySearchParams<boolean>(filterKey);

  const form = useForm();

  const updateQueryParams = useUpdateQueryParams();

  const onApply = (checked: boolean) => {
    const newParams: Record<string, any> = { page: 1 };
    newParams[filterKey] = checked || undefined;
    updateQueryParams(newParams);
  };

  return (
    <div className={styles.wrapper}>
      <Checkbox
        form={form}
        name={'headerFilterCheckbox'}
        checked={value ?? false}
        label={label}
        className={styles.checkbox}
        labelClassName={styles.label}
        onChange={(event) => onApply(event.target.checked)}
      />
    </div>
  );
};

export default HeaderFilterCheckbox;
